import type {
  BaselineInfo,
  Contract,
  ContractCost,
  ContractIn,
  EnergyFlow,
  ScenarioParams,
} from "./types";

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers ?? {}),
    },
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`${res.status} ${res.statusText}: ${text}`);
  }
  if (res.status === 204) return undefined as T;
  return res.json();
}

export const api = {
  health: () => request<{ status: string; version: string; baseline_present: boolean }>("/api/health"),
  baselineInfo: () => request<BaselineInfo>("/api/baseline/info"),

  listContracts: () => request<Contract[]>("/api/contracts"),
  getContract: (id: number) => request<Contract>(`/api/contracts/${id}`),
  createContract: (c: ContractIn) =>
    request<Contract>("/api/contracts", { method: "POST", body: JSON.stringify(c) }),
  updateContract: (id: number, c: ContractIn) =>
    request<Contract>(`/api/contracts/${id}`, { method: "PUT", body: JSON.stringify(c) }),
  deleteContract: (id: number) =>
    request<void>(`/api/contracts/${id}`, { method: "DELETE" }),

  simulate: (params: ScenarioParams) =>
    request<EnergyFlow>("/api/simulate", { method: "POST", body: JSON.stringify(params) }),
  evaluateAll: (params: ScenarioParams) =>
    request<ContractCost[]>("/api/evaluate-all", { method: "POST", body: JSON.stringify(params) }),
};
